<template>
  <ContentSection
    :class="!data.color_theme?.value || data.color_theme?.value === 'blue' ? `bg-theme-500 text-white` : `
      bg-theme-200
    `"
    :style="colorTheme"
  >
    <Container indent="lg" class="flex flex-col gap-8 md:flex-row sm:gap-16">
      <!-- IMAGE -->
      <div v-animate-zoom-in class="aspect-[31/38] w-full max-w-52 md:max-w-80">
        <AppImage
          v-if="teamMember?.image"
          :src="teamMember.image"
          :alt="useMapAltText(teamMember.image)"
          class="size-full rounded-tl-[3.75rem] object-cover"
        />
      </div>

      <!-- TEXT -->
      <div class="flex flex-col border-b-2">
        <div
          v-animate-children-in-from-bottom
          class="size-full max-w-container-text pb-10 sm:pb-16"
        >
          <h2
            v-if="data.heading"
            class="mb-8 typo-heading-xl sm:mb-10 sm:typo-display-lg"
            v-html="data.heading"
          />

          <!-- Name -->
          <h3 class="mb-4 typo-heading-md sm:mb-5 sm:typo-heading-lg">
            {{ teamMember?.title }}
          </h3>

          <!-- Function -->
          <p class="mb-1 typo-body-xl sm:typo-body-2xl">
            {{ teamMember?.function }}
          </p>

          <!-- Phone -->
          <a
            v-if="teamMember?.phone"
            class="
              mb-1 block w-fit underline underline-offset-4 transition-colors typo-body-xl
              sm:typo-body-2xl
            "
            :class="data.color_theme?.value ? 'hover:text-theme-400': 'hover:text-theme-200'"
            :href="`tel:${teamMember?.phone}`"
          >{{ `${$t('phone_short')} ${teamMember?.phone}` }}</a>

          <!-- Email -->
          <a
            v-if="teamMember?.email"
            class="
              mb-1 block w-fit underline underline-offset-4 transition-colors typo-body-xl
              sm:typo-body-2xl
            "
            :class="data.color_theme?.value ? 'hover:text-theme-400': 'hover:text-theme-200'"
            :href="`mailto:${teamMember?.email}`"
          >{{ teamMember?.email }}</a>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { ComponentsMainTeaserContactFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainTeaserContactFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const teamMember = computed(() => {
  return props.data.team_member
})

const colorTheme = useGetColorThemeStylesComponent(props.data.color_theme?.value)
</script>
